import type { Market } from '@/libs/market/market';
import { queryOptions } from '@tanstack/react-query';
import { QueriesKeys } from '../queriesKeys';
import { PUBLIC_QUERY_STALE_TIME } from '../queryOptions.helpers';
import { systemPagesApi } from './system-pages.api';

export const querySystemPage = {
  idOrAlias: (idOrAlias: string, market: Market) =>
    queryOptions({
      queryKey: [QueriesKeys.systemPage, idOrAlias, market],
      queryFn: () => systemPagesApi.getSystemPageByIdOrAlias(idOrAlias, market),
      staleTime: PUBLIC_QUERY_STALE_TIME,
      // select: data => data,
    }),
  list: (market: Market) =>
    queryOptions({
      queryKey: [QueriesKeys.systemPages, market],
      queryFn: () => systemPagesApi.getListOfSystemPages(market),
      staleTime: PUBLIC_QUERY_STALE_TIME,
    }),
};
